import styled from "styled-components";

export const Experience = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  padding: 30px;
  h2 {
    font-weight: 400;
  }
`;
export const Cells = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  border-bottom: 1px solid #9f9f9f;
  p {
    color: #9f9f9f;
  }
  h3 {
    color: rgb(204, 204, 204);
    font-weight: 500;
  }
  .icon {
    padding: 10px;
    background-color: white;
    display: flex;
    justify-content: center;
    border-radius: 10px;
  }
`;
export const Resume = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  max-width: 1400px;
  margin-inline: auto;
  background-color: black;
  @media (max-width: 950px) {
    grid-template-columns: 1fr;
  }
`;
export const Skills = styled.div`
  gap: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  div {
    background-color: #2a2a2a;
    height: 40px;
    width: fit-content;
    border-radius: 30px;
    display: flex;
    flex: 1 1 50;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px;
    font-size: 30px;
    line-height: 50px;
    @media (max-width: 560px) {
      height: 50px;
      width: 50px;
      flex: 1 1 50px;
      font-size: 20px;
    }
  }
`;
export const SkillsContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.266);
  max-width: 1000px;
  color: var(--color-main-text);
  margin-inline: auto;
  margin-top: 80px;
  margin-bottom: 100px;
  padding: 30px 30px 10px;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid var(--color-main-text);

  backdrop-filter: blur(10px) saturate(140%);
  -webkit-backdrop-filter: blur(10px) saturate(140%);
  h1 {
    font-size: 70px;
    font-weight: 900;
    margin: 20px;
    @media (max-width: 560px) {
      font-size: 30px;
    }
  }
  span {
    color: white;
  }

  @media (max-width: 768px) {
    padding: 20px 20px 5px;
  }
  @media (max-width: 1000px) {
    margin-inline: 20px;
  }
`;
export const AboutContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto 150px auto;
  padding: 0 20px;
  /* background-color: #ff000010; */
  z-index: -5;
  place-content: end space-between;
  @media (max-width: 900px) {
    grid-template-columns: 1fr; /* Stack vertically on small screens */
    text-align: center;
  }
`;

export const ProfileAboutPic = styled.img`
  margin: auto;
  transform: scaleX(-1);
  z-index: 1;
  object-fit: cover; /* crops */
  object-position: center;
  @media (max-width: 500px) {
    width: 100%;
  }
`;
